import { render, staticRenderFns } from "./StylePropertyControl.vue?vue&type=template&id=64d1a147&scoped=true&"
import script from "./StylePropertyControl.vue?vue&type=script&lang=js&"
export * from "./StylePropertyControl.vue?vue&type=script&lang=js&"
import style0 from "./StylePropertyControl.vue?vue&type=style&index=0&id=64d1a147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d1a147",
  null
  
)

export default component.exports